import { useId, Label, Option, mergeClasses, Dropdown } from '@fluentui/react-components';
import { IDropdownFieldProps } from '../BaseInputField/BaseInputField.types';
import { useBaseInputFieldStyles } from '../BaseInputField/BaseInputField.styles';

const DropdownField = (props: IDropdownFieldProps) => {
    const {
        name,
        label,
        placeholder,
        style,
        required,
        disabled,
        onChange,
        onExitFocus,
        values,
        className
    } = props;

    const inputId = `input-${name}`;
    const uniqueId = useId(`input-${name}`);

    const styles = useBaseInputFieldStyles();
    const dropdownStyle = mergeClasses(styles.inputField, className);

    return (
        <div className={className ? mergeClasses(styles.root, className) : styles.root}>
            <div>
                <Label htmlFor={inputId} className={styles.label}>
                    {label}
                </Label>
                {required && <span className={styles.requiredAsterisk}>*</span>}
            </div>
            <Dropdown
                id={uniqueId}
                data-testid={inputId}
                placeholder={placeholder}
                name={name}
                style={style}
                className={dropdownStyle}
                disabled={disabled}
                onOptionSelect={onChange}
                value={props.value}
                onBlur={onExitFocus}
            >
                {values?.map((value) => (
                    <Option key={value} value={value}>
                        {value}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};

export default DropdownField;
